// extracted by mini-css-extract-plugin
export default {"dotList":"DotList-module__dotList-Nui1","narrow":"DotList-module__narrow-jCtK"};